module.exports = __webpack_public_path__ + "static/media/icon-checkbox.3dc69f61.svg";